import {
  DocumentationViewItem,
  isDirectoryItemType,
  isFileItemType,
} from 'store/documentation/model/types';
import { OperationsSliceState } from './types';

export const INITIAL_OPERATIONS_STATE: OperationsSliceState = {
  selectedItems: new Set(),
  isOperationInProgress: false,
  preparedOperation: null,
};

export function collectItems(
  items: Set<DocumentationViewItem>,
  predicate?: (item: DocumentationViewItem) => boolean
): { documentations: number[]; directories: number[] } {
  const documentations: number[] = [];
  const directories: number[] = [];

  items.forEach((item) => {
    if (predicate && !predicate(item)) {
      return;
    }

    if (isDirectoryItemType(item.type)) {
      directories.push(item.localId);
    } else if (isFileItemType(item.type)) {
      documentations.push(item.localId);
    }
  });

  return { documentations, directories };
}
